import { ListboxOption } from '@headlessui/react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { DropdownSize } from '../types';
import { dropdownClasses } from '../styles';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDebounceCallback } from 'usehooks-ts';

export const DropdownSearchOption = ({
  search,
  setSearch,
  size,
}: {
  size: DropdownSize;
  search: string;
  setSearch: (search: string) => void;
}) => {
  const { t } = useTranslation();
  const debouncedSetSearch = useDebounceCallback(setSearch, 200);
  return (
    <ListboxOption
      as={'li'}
      key="search-option"
      value=""
      className="sticky top-0 z-10 flex w-full items-center gap-1 border-b border-gray-200 bg-white px-2"
    >
      <MagnifyingGlassIcon className="size-4 shrink-0 text-gray-400" />
      <input
        ref={(input) => {
          if (input) {
            input.focus();
          }
        }}
        defaultValue={search}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onChange={(e) => {
          e.preventDefault();
          e.stopPropagation();
          debouncedSetSearch(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.code === 'Space') {
            //We need to prevent the space key from
            e.stopPropagation();
          }
        }}
        placeholder={t('common:search.placeholder')}
        className={classNames(
          dropdownClasses.listItem.size[size],
          'min-w-0 border-0 !px-0 text-inherit focus:border-0 focus:outline-none focus:[box-shadow:none]',
        )}
      />
    </ListboxOption>
  );
};
